document.addEventListener("click", function(e) {
  const pill = e.target.closest(".variant-pill");
  if (!pill) return;

  const wrapper = pill.closest(".card-variants");
  const hiddenInput = wrapper.closest(".card-actions-wrapper").querySelector(".variant-id-field");

  const card = wrapper.closest(".card-wrapper") || wrapper.closest(".card");
  const priceEl = card?.querySelector('.price-item--regular, .price--main, .price, .card__price');
  const compareEl = card?.querySelector('.price-item--compare, .price__compare, .price--compare');
  const imageEl = card?.querySelector('.card__media img');

  wrapper.querySelectorAll('.variant-pill').forEach(p => p.classList.remove('active'));
  pill.classList.add('active');

  hiddenInput.value = pill.dataset.variantId;

  // Update price — keep same theme style
  if (priceEl && pill.dataset.variantPrice) {
    priceEl.innerHTML = `<span class="money">${pill.dataset.variantPrice}</span>`;
  }

  // Update compare price — keep same theme style
  if (compareEl) {
    if (pill.dataset.variantCompare && pill.dataset.variantCompare !== pill.dataset.variantPrice) {
      compareEl.innerHTML = `<span class="money compare-at-price">${pill.dataset.variantCompare}</span>`;
      compareEl.style.display = '';
    } else {
      compareEl.style.display = 'none';
    }
  }

  // Update image
  if (imageEl && pill.dataset.variantImage) {
    imageEl.src = pill.dataset.variantImage;
    imageEl.srcset = pill.dataset.variantImage;
  }
});
